// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b6d77b8f","455":"127cb8bf","977":"bc7ae0d3"}[chunkId] + ".chunk.js";
};